import React, { useState, useEffect } from "react";
import { SectionTitle } from "components/items";
import { loadNavermapsScript } from "react-naver-maps";

import makeTitle from "function/makeTitle.js";
import image_sample from "image/map/map_sample.png";
import { factory_1_kr, factory_1_en, factory_2_kr, factory_2_en } from "../../field";

// firebase
import firebase from "library/firebase-config.js";
import "firebase/firestore";
var db = firebase.firestore();

const sectionTitle = [
	{
		text: "FACTORY",
		color: "defualt",
		break: false,
	},
	{
		text: "MAP",
		color: "main",
		break: true,
	},
];

const listMap_text = {
	type: "text",
	title: "공장 위치 및 근무시간 안내",
	text:
		"동구밭 팩토리의 고객이 원하는 제품을 만들어내는 뛰어난 품질관리와 기술력에 많은 파트너가 함께 했습니다. 동구밭 팩토리는 고객의 브랜드에 적합한 컨셉과 품질에 가장 적합한 아이디어를 제공하는 함께 성장하는 준비된 파트너입니다.",
	img: null,
};

const Map = (props) => {
	const [loading, setLoading] = useState(false);
	// state
	const [map_01, set_map_01] = useState({
		id: "map_01",
		type: "image",
		title: "제 1 공장(본사)",
		text_kr: factory_1_kr,
		text_en: factory_1_en,
		text: null,
		img: image_sample,
		location: [0, 0],
	});

	const [map_02, set_map_02] = useState({
		id: "map_02",
		type: "image",
		title: "제 2 공장",
		text_kr: factory_2_kr,
		text_en: factory_2_en,
		text: null,
		img: image_sample,
		location: [0, 0],
	});

	const [map_03, set_map_03] = useState({
		id: "map_03",
		type: "image",
		title: "제 3 공장",
		text: null,
		img: image_sample,
		location: [0, 0],
	});

	const listMap_withText_arr = [listMap_text, map_01, map_02];
	const [listMaps, setListMaps] = useState([map_01, map_02, map_03]);
	const listSetMaps = [set_map_01, set_map_02, set_map_03];

	const _getMap = () => {
		db.collection("home")
			.doc("maps")
			.get()
			.then((doc) => {
				doc.data().items.forEach((element) => {
					// element.label : 제 1 공장
					const location = element.contents.map((content) => {
						return content.value;
					});

					// 지도 좌표 배열
					listMaps.forEach((map, index) => {
						if (map.title === element.label) {
							map.location = location;
							listSetMaps[index](map);
						}
					});
				});
			})
			.then((res) => {
				setLoading(true);
			});
	};

	useEffect(() => {
		_getMap();
		initNaverMap();
	});

	useEffect(() => {
		setListMaps([map_01, map_02, map_03]);
	}, [map_01, map_02, map_03]);

	const initNaverMap = () => {
		loadNavermapsScript({
			clientId: "myj8jtdg36",
		}).then((navermaps) => {
			if (loading) {
				drawNaverMap(navermaps, map_01);
				drawNaverMap(navermaps, map_02);
			}
		});
	};

	const drawNaverMap = (navermaps, el) => {
		const map = new navermaps.Map(el.id, {
			useStyleMap: true,
			center: new navermaps.LatLng(el.location[0], el.location[1]),
			zoom: 14,
		});

		new navermaps.Marker({
			position: new navermaps.LatLng(el.location[0], el.location[1]),
			map: map,
		});
	};

	const drawMap = (arr) => {
		return arr.map((el, index) => {
			return (
				<div className="list-map" key={`mapList-${index}`}>
					<p className="list-map-title">{el.title}</p>
					{el.type === "image" ? (
						<div className="wrap-listMap">
							<div className="map-contents">
								<div id={el.id} style={{ width: "100%", height: "100%" }}></div>
							</div>
						</div>
					) : (
						<p>{el.text}</p>
					)}

					{el.type === "image" ? (
						<div className="wrap-text">
							<p className="text-kr">{el.text_kr}</p>
							<p className="text-en">{el.text_en}</p>
						</div>
					) : (
						""
					)}
				</div>
			);
		});
	};

	return (
		<section className={`Map ${props.className}`}>
			<div className="section-header">
				<div className="con">
					<SectionTitle text={makeTitle(sectionTitle)} type="left" />
				</div>
			</div>

			<div className="section-contents">
				<div className="con">{drawMap(listMap_withText_arr)}</div>
			</div>
		</section>
	);
};

export default Map;
